/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".col-body-border-right[_ngcontent-%COMP%]{padding-left:0}.required-validation[_ngcontent-%COMP%]{color:red;position:absolute;top:8px!important;left:80px!important;font-size:13px;font-weight:600}.alert-danger[_ngcontent-%COMP%]{color:#fffffc;background-color:#b51b0c;border-color:#8c1004;font-size:12px;font-weight:600;padding:8px 12px;text-align:center;margin-top:6px;margin-bottom:0}.required-validation-star[_ngcontent-%COMP%]{color:red;position:absolute;top:4px!important;right:4px!important;font-size:14px;font-weight:600}"];
export { styles as styles };
